// ADA Key
export const PAGE_ADA_KEY = 'page_ada';
export const PAGE_NO_ADA_KEY = 'page_no_ada';

// Page Key Selectors
export const HOME_KEY = 'home';

// Banking Type Selectors
export const MB = 'mb';
export const OLB = 'olb';
export const MPOS = 'mpos';
export const ESSENTIALS = 'essentials';

export const MOBILE_DEMO = 'mobileDemo';
export const ONLINE_DEMO = 'onlineDemo';
export const MPOS_DEMO = 'mposDemo';
export const ESSENTIALS_DEMO = 'essentialsDemo';